import { render, staticRenderFns } from "./ranking-and-placement.vue?vue&type=template&id=78fb7990&scoped=true"
import script from "./ranking-and-placement.vue?vue&type=script&lang=js"
export * from "./ranking-and-placement.vue?vue&type=script&lang=js"
import style0 from "./ranking-and-placement.vue?vue&type=style&index=0&id=78fb7990&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78fb7990",
  null
  
)

export default component.exports